<template>
  <g>
    <path
      d="M21 14.0002C21 13.4502 20.55 13.0002 20 13.0002H18V15.0002H20C20.55 15.0002 21 14.5502 21 14.0002Z"
    />
    <path
      d="M20 17.0002H18V19.0002H20C20.55 19.0002 21 18.5502 21 18.0002C21 17.4502 20.55 17.0002 20 17.0002Z"
    />
    <path
      d="M16 12.0002H14C12.9 12.0002 12 12.9002 12 14.0002H11C10.45 14.0002 10 14.4502 10 15.0002V17.0002C10 17.5502 10.45 18.0002 11 18.0002H12C12 19.1002 12.9 20.0002 14 20.0002H16C16.55 20.0002 17 19.5502 17 19.0002V13.0002C17 12.4502 16.55 12.0002 16 12.0002Z"
    />
    <path
      d="M5 13.0002C5 11.9002 5.9 11.0002 7 11.0002H8.5C10.43 11.0002 12 9.43018 12 7.50018C12 5.57018 10.43 4.00018 8.5 4.00018H5C4.45 4.00018 4 4.45018 4 5.00018C4 5.55018 4.45 6.00018 5 6.00018H8.5C9.33 6.00018 10 6.67018 10 7.50018C10 8.33018 9.33 9.00018 8.5 9.00018H7C4.79 9.00018 3 10.7902 3 13.0002C3 15.2102 4.79 17.0002 7 17.0002H9V15.0002H7C5.9 15.0002 5 14.1002 5 13.0002Z"
    />
  </g>
</template>
